// src/pages/secondLife/offeneFaelleAuswahl.js
//
// Die reine Auswahl der „offenen Faelle" fuer das Karussell: was einen Menschen
// erwartet. Zwei Lagen sind das — noch kein Produkt (`none`) oder ein Entwurf,
// der auf Freigabe wartet (`draft`).
//
// 🔴 `anlegbar` ist die Bedingung des Grundprodukts (Stufe in ANLEGBARE_STUFEN
// UND A-Produkt vorhanden), NICHT des Zustands. Ohne A-Produkt gibt es nichts
// anzulegen — auch dann nicht, wenn der Zustand `none` ist.
//
// 🔴 DEF faellt schon ueber `anlegbar` heraus (DEF ist nie in ANLEGBARE_STUFEN).
// Die Pruefung steht hier trotzdem als eigene Zeile, weil sie sonst nur
// mittelbar gilt und ein spaeterer Umbau sie still verlieren koennte.
//
// ── Die Anzeige kennt SECHS Zustaende, offen sind ZWEI ───────────────────────
//
//   none · draft · live · hidden · zurueck · ausgesondert
//   ^^^^^^^^^^^^^ offen                       ^^^^^^^^^^^^^^^^^^ ausdruecklich nicht
//
// 🔴 Die Auswahl ist eine ERLAUBNISLISTE, keine Verneinung. Eine Sperrliste
// (`state !== 'live' && state !== 'hidden' && …`) waere bei jeder neuen Lage
// still falsch geworden: der neue Zustand faellt durch jede Bedingung hindurch
// und landet im Karussell. Hier ist umgekehrt alles offen, was ausdruecklich
// dasteht — auch ein spaeter erfundener Zustand ist damit NICHT offen.
//
// 🔴 `ausgesondert` ist NICHT dabei, und das ist der eigentliche Punkt dieser
// Zeile. `discarded` heisst AUSSCHUSS (`discard()` schreibt
// `stock_disposition='scrap'`), nicht „verworfener Entwurf". Bis zum
// 2026-10-09 fiel die Lage auf `none` und stand damit im Karussell — mit einem
// „Annehmen"-Knopf, der fuer ausgeschlachtete Ware einen neuen Shopify-Entwurf
// angelegt haette. Derselbe Grund schliesst `zurueck` aus: zurueckgekommene
// Ware wartet nicht darauf, neu angelegt zu werden.

export const DEF = 'DEF';

/** Die zwei Zustaende, die einen Menschen erwarten. Reihenfolge = Anzeige. */
export const OFFENE_ZUSTAENDE = ['none', 'draft'];

export function offeneFaelle(zeilen) {
  return (zeilen || []).filter(
    (z) => z.grade !== DEF && z.anlegbar && OFFENE_ZUSTAENDE.includes(z.state),
  );
}
